import { Component, Inject} from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { cloneDeep, filter, find } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { DriveUploadQueue } from '../../models/DriveUploadQueue';
import { DocumentManagerService } from '../../services/document-manager.service';

@Component({
    selector: 'app-document-upload-queue',
    templateUrl: './document-upload-queue.component.html',
    styleUrls: ['./document-upload-queue.component.scss']
})
export class DocumentUploadQueueComponent {
    public UploadQueue: DriveUploadQueue[] = [];
    public State = {
        UploadCount: 0,
        Completed: false,
        Display: true,
        Uploading: false
    };
    public $UploadQueue: BehaviorSubject<DriveUploadQueue[]> = new BehaviorSubject([]);
    public $UploadQueueSteam = this.$UploadQueue.asObservable();

    constructor(
        private _DocumentManagerService: DocumentManagerService,
        private readonly bottomSheetRef: MatBottomSheetRef<DocumentUploadQueueComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    ) {
        this.UploadQueue = this.data;
        this.$UploadQueue.next(this.UploadQueue);
        this.updateState(this.UploadQueue);
        this._DocumentManagerService.UploadEvent.subscribe({
            next: (resp) => {
                const tempQ = cloneDeep(this.UploadQueue);
                const file = find(tempQ, { ItemId: resp['ItemId'] });
                if (file) {
                    file.Percentage = resp['Percentage'];
                }
                this.UploadQueue = tempQ;
                this.$UploadQueue.next(this.UploadQueue);
                this.updateState(this.UploadQueue);
            },
            error: (error) => {
                console.log(error);
            },
            complete: () => {
                console.log('finished');
            }
        });
    }

    Actions = {
        Close: () => {
            this.bottomSheetRef.dismiss();
            this.UploadQueue = [];
            this.$UploadQueue.next(this.UploadQueue);
        }
    };

    updateState(_UploadQueue) {
        this.State.Display = _UploadQueue.length > 0;
        const UploadingLength = filter(_UploadQueue, file => file.Percentage < 100).length;
        const CompletedLength = filter(_UploadQueue, file => file.Percentage === 100).length;
        this.State.Uploading = UploadingLength > 0;
        this.State.Completed = CompletedLength === _UploadQueue.length;
        if(this.State.Completed || filter(_UploadQueue, file => file.Percentage == -1).length){
            setTimeout(() => {
                this.Actions.Close();
            }, 1000);
        }
    }
}
